/**
 * retourne un code unique de langue "fr-Fr" vers "fr"
 */

export function txtSimpleLang(code: string) {
    return code.includes("-") ? code.split("-")[0] : code;
}